export const firebaseConfig = {
    apiKey: 'AIzaSyAtA2xs_2JM254PZCku5Q0F205I7FeeyzU',
    authDomain: 'marinesamraj.firebaseapp.com',
    projectId: 'marinesamraj',
    storageBucket: 'marinesamraj.appspot.com',
    messagingSenderId: '165762179517',
    appId: '1:165762179517:web:f7e8bbbf026b25f3db32d4',
    measurementId: 'G-B1D5W034RW',
};
